import Vue from 'vue'
import Vuex from 'vuex'
import {
  getUserInfo
} from "@/api/auth";
import {
  removeToken,
  setToken
} from "@/util/cookie";
import {
  removeStore,
  setStore
} from "@/util/storage";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dept: {},
    project: {},
    item: {},
    rule: {},
    user: {},
    busi: {},
    grade: 0,
    userInfo: {
      ...JSON.parse(sessionStorage.getItem("userInfo"))
    }
  },
  mutations: {
    setGrade(state, data) {
      state.grade = data
    },
    setDept(state, data) {
      state.dept = data
    },
    resetDept(state) {
      state.dept = {}
    },
    setProject(state, data) {
      state.project = data
    },
    setItem(state, data) {
      state.item = data
    },
    reSetProject(state) {
      state.project = {}
    },
    setRule(state, data) {
      state.rule = data
    },
    reSetRule(state) {
      state.rule = {}
    },
    setUser(state, data) {
      state.user = data
    },
    reSetUser(state) {
      state.user = {}
    },
    setBusi(state, data) {
      state.busi = data
    },
    reSetBusi(state) {
      state.busi = {}
    }

  },
  getters: {
    getGrade: (state) => state.grade,
  },
  actions: {
    setUserInfo({
      commit
    }, uid) {
      return new Promise((resolve, reject) => {
        getUserInfo(uid).then(res => {
          setToken(uid)
          setStore("userInfo", res.data.info)
        })
      })
    },
    removeUserInfo({
      commit,
      data
    }) {
      return new Promise((resolve) => {
        removeToken()
        removeStore("userInfo")
      })
    }
  }
})